export const HEY_IMMO_TREATMENT_GA_PARAMETER = 'PPA-12798-treatment'

type HeyImmoExperimentTrackingParameters = {
  ga_cd_test_ppa: string
}

type HeyImmoExperimentStateParams = {
  isHeyImmoSupported: boolean
}

type HeyImmoExperimentState = {
  trackingParameters?: HeyImmoExperimentTrackingParameters
}

export function getHeyImmoExperimentState({
  isHeyImmoSupported,
}: HeyImmoExperimentStateParams): HeyImmoExperimentState {
  if (!isHeyImmoSupported) {
    return {}
  }

  return {
    trackingParameters: {
      ga_cd_test_ppa: HEY_IMMO_TREATMENT_GA_PARAMETER,
    },
  }
}
